module.exports = __webpack_public_path__ + "static/media/event.1e2387a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/event.jpg
// module id = 385
// module chunks = 4